import React, { Fragment } from 'react';
import { array, object, string } from 'prop-types';

import PanelHotels from './components/PanelHotels';
import PanelMap from './components/PanelMap';

function App({ allPlaces = [], API_KEY, hotels, theme }) {
  
  const hotelsLen = hotels.length;

  const hotelsCountries = [];

  hotels.map(hotel =>
    hotelsCountries.push(hotel.country)
  );

  const countriesLen = Array.from(new Set(hotelsCountries));

  return (
    <Fragment>
      <PanelMap API_KEY={API_KEY} hotels={hotels} theme={theme} />
      <PanelHotels allPlaces={allPlaces} hotelsLen={hotelsLen} countriesLen={countriesLen.length} theme={theme} />
    </Fragment>
  );
}

App.propTypes = {
  allPlaces: array.isRequired,
  API_KEY: string.isRequired,
  hotels: array,
  theme: object.isRequired
};

export default App;
